var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-14.9,-15)"},React.createElement("path",{"d":"M28.6229 24.908L22.1004 28.7059V21.1101L28.6229 24.908ZM34.7326 28.4582V21.3577C34.7326 21.3577 34.7326 17.9727 31.3475 17.9727H18.3851C18.3851 17.9727 15 17.9727 15 21.3577V28.4582C15 28.4582 15 31.8433 18.3851 31.8433H31.3475C31.2649 31.8433 34.7326 31.8433 34.7326 28.4582Z","fill":"currentColor"})));
}

Youtube.defaultProps = {"viewBox":"0 0 20 20","fill":"none","style":{"color":"#39424A"}};

module.exports = Youtube;

Youtube.default = Youtube;
